@if (model) {
<div class="wrap-x wrap-l flex-x flex-l flex-m p-t p-b"
     [elementHeight]="'blog-post-view'">
    @if (!client.isS) {
    <div class="w-1">
        <ng-container *ngTemplateOutlet="navElementSticky; context: {post: nav?.prev, side: 'left' }" />
    </div>
    }
    <div class="w-10 w-12-s center">
        @switch (model.data.typeData.variant) {

        <!-- LAYOUT 1 -->
        @case ('var_1') {
        <icms-component [data]="getComponent('image-with-copy')" />
        }

        <!-- LAYOUT 2 -->
        @case ('var_2') {
        <ng-container *ngTemplateOutlet="postDetails" />
        <icms-component [data]="getComponent('image-with-overlapping-copy')" />
        }
        }

        <!-- upper cms-outlet (10 cols) -->
        <icms-outlet [components]="typeData.topComponents" />
    </div>
    @if (!client.isS) {
    <div class="w-1">
        <ng-container *ngTemplateOutlet="navElementSticky; context: {post: nav?.next, side: 'right' }" />
    </div>
    }
</div>

<!-- POST BOTTOM -->
<div id="post-nav-cutout"></div>

<!-- MAIN OUTLET -->
<div class="wrap-x wrap-l">
    <icms-outlet [components]="model.data.components" />
</div>

<!-- RELATED ARTICLES -->
@if (relatedArticles?.length) {
<div class="bg-col-33">
    <div class="wrap-x wrap-l p-t-5 p-b-7 center">
        <div class="w-11 w-12-s p-l p-r p-l-3-s p-r-3-s p-t-5-s center">
            <h6 class="h2">{{'Related articles' | translate}}</h6>
            <div class="left m-t-5 m-t-6-s">
                @for (relatedArticle of relatedArticles; track relatedArticle.id) {
                <div class="center c-4-set c-12-set-s"
                     [class.m-t-10-s]="!$first">
                    <href [link]="relatedArticle.data.url">
                        <img class="w-12"
                             [dfImage]="relatedArticle.data.image"
                             ratio="4/3">
                    </href>
                    <p class="h3 p-t-2 p-l p-r">{{relatedArticle.data.name}}</p>
                </div>
                }
            </div>
        </div>
    </div>
</div>
}
}

<!--------------------

    TEMPLATES

--------------------->

<!-------------------- POST DETAILS -------------------->
<ng-template #postDetails>
    @if (client.isS) {
    @if (nav) {
    <div class="w-12 flex flex-justify-between flex-middle">
        <div class="min-width p-l p-r-1">
            <ng-container *ngTemplateOutlet="navElement; context: {post: nav.prev, side: 'left' }" />
        </div>
        <div class="col-11 o1 uppercase">{{typeData.date | date : 'mediumDate'}}</div>
        <div class="min-width p-l-1 p-r">
            <ng-container *ngTemplateOutlet="navElement; context: {post: nav.next, side: 'right' }" />
        </div>
    </div>
    }
    } @else {
    <div class="col-11 o1 uppercase">
        {{typeData.date | date : 'mediumDate'}}
    </div>
    }
    @if (typeData.title) {
    <h1 class="m-t m-b m-t-7-s m-b-7-s h2 w-9">
        {{typeData.title | translate}}
    </h1>
    }
</ng-template>


<!-------------------- PREV/NEXT sticky navigation button -------------------->
<ng-template #navElementSticky
             let-post="post"
             let-side="side">
    @if (post) {
    <sticky-free class="post-view-sticky"
                 [stickyId]="'sticky-post-view'"
                 [stickyOffset]="'page-header-wrapper'"
                 [stickyOff]="client.isCms"
                 [order]="2">
        <ng-container *ngTemplateOutlet="navElement; context: {post: post, side: side }" />
    </sticky-free>
    }
</ng-template>

<!-------------------- PREV/NEXT post icon template -------------------->
<ng-template #navElement
             let-post="post"
             let-side="side">
    <div class="text-rotation">
        @if (post) {
        <a class="flex-s flex-middle-s"
           [class.flex-reverse-s]="side === 'right'"
           [routerLink]="post.data?.url">
            @if (!client.isS) {
            <div class="rotation-wrapper-inner"
                 [sizeClass]="'XL: h3, MS: h4'">
                @if (post === nav.next) {
                <div class="text-rotation-next uppercase">{{'Next Article' | translate}}</div>
                }
                @if (post === nav.prev) {
                <div class="text-rotation-prev uppercase">{{'Previous Article' | translate}}</div>
                }
            </div>
            } @else {
            <i class="fs-4 icon-arrow-forward"
               [class.arrow-rotation]="side === 'left'">
            </i>
            }
        </a>
        }
    </div>
</ng-template>